import { message } from 'antd'
import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import FileTreeData from 'meinian-package/src/common/fileTreeData'
import Modal from 'meinian-package/src/component/modal'
import TreeOption from 'meinian-package/src/component/inspirationTreeList'
import request from 'meinian-package/src/utils/request'
import styles from './index.module.less'

const MoveInspiration = ({ visible, id, onOk, onCancel, onChange }) => {
  const [_visible, set_Visible] = useState(visible)
  const [treeOption, setTreeOption] = useState([])
  const [loading, setLoading] = useState(false)
  const treeData = useRef(null)

  const [keyWords, setKeyWords] = useState()
  const pageParams = useRef({
    start: 0,
    pageSize: 20
  })
  const resultList = useRef([])
  const totalRef = useRef(0)

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    const flag = await onOk?.()
    if (flag === false) {
      return
    }
    set_Visible(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const onMove = async (toInspiration, forceMove = 0) => {
    try {
      await request.post('/zhikuan/ins/inspiration/move-child-inspiration', {
        inspirationId: id,
        parentId: toInspiration.id,
        forceMove
      })
      const currentTreeNode = treeData.current.findNodeByValue(toInspiration.id)
      const curItem = currentTreeNode.brother.find(item => item.value === toInspiration.id)
      onChange && onChange(toInspiration.id, curItem)
      message.success(<span>已成功移动至<a className="link" href={`/meinian/home/coll/detail/${toInspiration.id}?inspirationId=${toInspiration.id}`} target="_blank" rel="noreferrer">{toInspiration.name}</a></span>)
    } catch (err) {
      if (err.errorCode === 'INSPIRATION_ERROR_0002') {
        Modal.show({
          title: '提醒',
          children: '目标灵感集中已经存在了同名子灵感集，继续移动灵感集后，我们将为当前子灵感集补充名称以进行区分？',
          okText: '继续移动',
          onOk: () => onMove(toInspiration, 1)
        })
      }
    }
  }

  const fetchData = async (
    _keyWords = keyWords,
    _pageParams = pageParams.current,
  ) => {
    setLoading(true)
    const res = await request.post('/zhikuan/ins/inspiration/list-collect-inspiration-tree', {
      ..._pageParams,
      likeName: _keyWords,
    })
    totalRef.current = res.resultCount
    const tempResult = _pageParams.start === 0 ? resultList.current = res.resultList : resultList.current = [...resultList.current, ...res.resultList]
    treeData.current = new FileTreeData({
      data: tempResult,
      childrenKey: 'childs',
    })
    treeData.current.checkMoveAllMarkStatus(id)
    setTreeOption(treeData.current.data)
    setLoading(false)
  }

  return <Modal
    onCancel={_cancel}
    onOk={_ok}
    title="移动到灵感集"
    visible={_visible}
    style={{ width: '640px', borderRadius: '3px' }}
    hiddenFooter
    className={styles['mn-inspiration-image-modal']}
  >
    <div className={styles['move-inspiration-modal-content']}>
      <TreeOption
        onLoad={() => {
          pageParams.current.start += 20
          if (pageParams.current.start < totalRef.current) {
            fetchData()
          }
        }}
        keyWords={keyWords}
        onKeyWords={(val) => {
          pageParams.current.start = 0
          fetchData(val)
          setKeyWords(val)
        }}
        collectBtn="移动"
        singleCollection
        hasMove
        onItemCollect={(inspirationId, inspiration) => onMove(inspiration)}
        onChooseTaskClose={_cancel}
        onChooseTaskOk={_cancel}
        onCancel={_cancel}
        treeData={treeData.current}
        data={treeOption}
        scrollHeight={546}
        loading={loading}
        onCreateInspiration={(_id, _name, _current) => onMove(_current)}
      />
    </div>
  </Modal>
}

export const useMoveInspiration = (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<MoveInspiration {...props} visible container={div} />, div)
  })
}
